import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Grid } from "@mui/material";
import { useCreateAgentMutation } from "api/agents/agents.mutation";
import { Modal } from "components/Modal";
import TextField from "components/TextField";
import { handleError } from "functions/apiHandleError";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { schema } from "schema/agents/createUpdateModal";
import classes from "./style.module.scss";

export const CreateUpdateAgentModal = ({ open, onClose, defaultData }) => {
  const { handleSubmit, reset, setError, control } = useForm({
    mode: "onChange",
    resolver: zodResolver(schema),
  });

  const createAgentMutation = useCreateAgentMutation();

  const handleCloseModal = () => {
    reset();
    onClose();
  };
  const handleSubmitForm = async (data) => {
    try {
      await createAgentMutation.mutateAsync({ ...data });
      toast.success("با موفقیت انجام شد");
      handleCloseModal();
    } catch (err) {
      handleError({ err, setError });
    }
  };

  return (
    <Modal
      open={open}
      title={defaultData ? "ویرایش ایجنت" : "ایجاد ایجنت"}
      onClose={handleCloseModal}
      maxWidth="sm"
      footerEnd={
        <>
          <Button
            variant="contained"
            size="xsmall"
            loading={createAgentMutation.isPending}
            color={defaultData ? "primary" : "success"}
            onClick={handleSubmit(handleSubmitForm)}
          >
            ثبت
          </Button>
          <Button variant="contained" color="error" size="xsmall" onClick={handleCloseModal}>
            بستن
          </Button>
        </>
      }
    >
      <Grid
        container
        spacing={3}
        component="form"
        onSubmit={handleSubmit(handleSubmitForm)}
        className={classes.wrapper}
      >
        <Grid item xs={12}>
          <TextField label="ایمیل ایجنت" required control={control} name="email" />
        </Grid>
        {!defaultData && (
          <Grid item xs={12}>
            <TextField label="رمزعبور" required type="password" control={control} name="password" />
          </Grid>
        )}
      </Grid>
    </Modal>
  );
};
